import { Box, Typography } from "@mui/material";
import React from "react";
import { getResponsiveSize } from "../../utils/responsive";
import globalStyles from "../../global";

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

// Now accepts title prop (and optionally date, time, location)
const PastEventBanner = ({ title, date, time, location }) => {
  return (
    <Box sx={styles.mainBox}>
      <Box sx={styles.innerBox}>
        <Box sx={styles.rightBox}>
          <Box sx={styles.titleWrapper}>
            <Typography variant="title_banner">{title}</Typography>
          </Box>
          {(date || time || location) && (
            <Box sx={styles.infoStack}>
              {date && (
                <Box sx={styles.infoItem}>
                  <Typography sx={styles.infoText}>{date}</Typography>
                </Box>
              )}
              {time && (
                <Box sx={styles.infoItem}>
                  <Typography sx={styles.infoText}>{time}</Typography>
                </Box>
              )}
              {location && (
                <Box sx={styles.infoItem}>
                  <Typography sx={styles.infoText}>{location}</Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainBox: {
    minHeight: {
      xs: "auto",
      sm: getResponsiveSize(200),
      md: getResponsiveSize(622),
    },
    width: "100%",
    py: { xs: 2, sm: 6 },
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden",
    display: "flex",
    backgroundImage: `url(${imageBaseUrl}pastEventBanner.png)`,
  },
  innerBox: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  rightBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: { xs: getResponsiveSize(4), md: 10 },
    marginBottom: { xs: getResponsiveSize(8), md: 10 },
    width: {
      xs: "90%",
      md: "80%",
    },
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    mb: { xs: 2, sm: 3 },
  },
  title: {
    color: "white",
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 800,
    lineHeight: 1.1,
    textAlign: "center",
    textTransform: "uppercase",
    fontSize: {
      xs: getResponsiveSize(40),
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
    maxWidth: getResponsiveSize(1100),
  },
  infoStack: {
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: {
      xs: "center",
      sm: "space-evenly",
    },
    alignItems: "center",
    mb: { xs: 3, sm: 4 },
    rowGap: { xs: 2, sm: 0 },
    width: { xs: "100%", sm: "auto" },
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: {
      xs: "100%",
      sm: "auto",
    },
    px: { xs: 2, sm: 0 },
  },
  infoText: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    color: globalStyles.colors.white,
    ml: "4px",
    fontSize: {
      xs: getResponsiveSize(12),
      sm: getResponsiveSize(16),
      md: getResponsiveSize(18),
    },
    textAlign: "left",
    whiteSpace: { xs: "normal", sm: "nowrap" },
  },
};

export default PastEventBanner;
